<template>
  <b-modal id="tracking-source-modal" centered title="New Category" hide-footer no-close-on-backdrop @hidden="clearData">
      <b-form @submit.prevent="store">
        <label for="name" class="form-control-label">New Category:</label>
        <b-input-group size="sm">
          <b-form-input label="Add New Category:" v-model="name" placeholder="Category Name..." size="sm"></b-form-input>
          <b-input-group-append>
            <b-button size="sm" type="submit" variant="success">Submit</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form>
      <div v-if="trackingSources" class="mt-2">
        <h4>Custom Categories:</h4>
        <b-list-group size="sm">
          <b-list-group-item v-for="source in trackingSources" :key="source.id">{{ source.name }} <b-button variant="danger" size="sm" @click="destroy(source.id)" class="float-right">Delete</b-button></b-list-group-item>
        </b-list-group>
      </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    userRoute: null,
    trackingSources: null,
    type: null
  },
  data: function() {
    return {
      name: null
    }
  },
  methods: {
    async store() {
      await axios.post(this.userRoute + "/tracking-sources", {
        name: this.name,
        type: this.type
      })
      .then(response => {
        this.$emit('getTrackingSources');
        this.$emit('getItems');
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$bvModal.hide('tracking-source-modal');
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async destroy(source) {
      await axios.delete(this.userRoute + "/tracking-sources/" + source)
      .then(response => {
        this.$emit('getTrackingSources');
        this.$emit('getItems');
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearData() {
      this.name = null;
    }
  }
};
</script>